module.exports = __webpack_public_path__ + "img/Iced Coffee.a0963dc2.svg";